export default __webpack_public_path__ + "static/fonts/PFBagueSansPro-Italic-BTU65BKL.woff2!static";